import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import {
  LoginCard,
  EmailLoginForm,
  SubmitGoButton,
  PlatformButtons,
} from '@streamlabs-core/sl-one-fe-components-vue2';
import feSdk from '@streamlabs-core/sl-one-fe-sdk';
import { EAnalyticsEvent } from '@/helpers/analytic';
import UtilHelper from '@/helpers/utils';
import { EUserAdEvent } from '@/helpers/user';

@Component({
  components: {
    LoginCard,
    EmailLoginForm,
    SubmitGoButton,
    PlatformButtons,
  },
})
export default class SLLoginForm extends Base {
  isConnecting: boolean = false;
  formDisabled: boolean = false;

  get thirdPartyPlatformButtons(): string[] {
    return ['twitch'];
  }

  get thirdPartyPlatformIcons(): any {
    return [];
  }

  onPlatformAuth(data) {
    const platform = data[0];
    this.$sla.sendEvent(EAnalyticsEvent.slNativeOnPlatformClick);

    switch (platform) {
      case 'twitch':
        window.open('/auth/twitch', '_self');
        UtilHelper.trackGTMEvent({ event: EUserAdEvent.logIn });
        break;
      default:
        break;
    }
  }

  onLoginAttempt(data) {
    this.isConnecting = true;
    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginAttempt);
  }

  onLoginError(error) {
    this.isConnecting = false;
    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginFailure, { error: error });
  }

  async onSlidLogin(sessionUser) {
    await this.slidModule.setSLIDSession(sessionUser);

    if (sessionUser.email_verified === false) {
      return this.onRedirectRequested('email');
    }

    await this.startDirectConnect();
  }

  onRedirectRequested(to: string) {
    if (to === 'signup')
      this.$router.push('/signup');

    if (to === 'email')
      this.$router.push('/verify-email');

    if (to === 'forgot')
      this.$router.push('/forgot');

    if (to === 'tfa')
      this.$router.push('/verify-tfa');
  }

  handleVerificationRequired(type) {
    switch (type) {
      case 'email':
        this.onRedirectRequested('email');
        break;

      case 'tfa':
        this.onRedirectRequested('tfa');
        break;

      case 'age-gate':
        //this.onRedirectRequested('age-gate');
        break;

      default:
        break;
    }
  }

  async startDirectConnect() {
    const { redirect_url } = await feSdk.api.identity.connectIdentity({
      origin: window.location.origin,
      pk: feSdk.env.get().services.identity.pk,
      intent: 'connect',
      state: btoa(JSON.stringify({ r: '/projects' })),
    });

    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginSuccess);
    window.location.href = redirect_url;
  }
}


